// src/components/ProtectedRoute.js
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getToken } from "../utils/getToken";

const ProtectedRoute = ({ redirectPath = "/login" }) => {
  const isAuthenticated = getToken("adminLogin");
  if (!isAuthenticated) {
    return <Navigate to={redirectPath} replace />;
  }
  return <Outlet />;
};

export default ProtectedRoute;
